var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-pill",
    {
      staticClass: "rb-3d-toggle",
      class: { "rb-3d-toggle--skeleton": _vm.skeletonIsVisible },
      attrs: {
        "data-element-id": _vm.dataElementId,
        "data-description": _vm.dataDescription,
        color: _vm.getColor,
        role: "button",
        tabindex: "0",
      },
      on: { click: _vm.onClick },
    },
    [_vm._v(_vm._s(_vm.label))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }